import React from 'react'
import Navbar from './Navbar'

function Terms() {
  return (
    <>
       <div className="main">
        <div className="main-div">
      <div className="container mt-3 mb-4">
<div className="">
              <Navbar />
            </div>
            <div className='container mt-4 '>
            <div className='mt-5'>
              <h2 className='text-center'>Terms and Conditions</h2>
              <div mt-4>
                <p>
                 Welcome to shareitforpcappdownload.com. By accessing or using our website, you agree to comply with and be bound by the following Terms and Conditions.
                 <p>If you do not agree with these terms, please do not use our website.</p>
                </p>
              </div>
                <h5>1. Use of Website</h5>
                <p>Our website provides quiz-based entertainment and educational content across multiple categories.</p>
                <p>You agree to use the website only for lawful purposes and in a way that does not harm, disrupt, or misuse the platform.</p>
              
            

              <div className='mt-4'>
                <h5>2. User Responsibilities</h5>
                <p>By using this website, you agree that you will not:</p>
                <ul>
                  <li>Cheat, manipulate, or exploit quiz systems</li>
                  <li>Use bots, scripts, or automated tools</li>
                  <li>Attempt to hack or damage the website</li>
                  <li>Copy or redistribute website content without permission</li>
                  <li>Engage in abusive or harmful behavior</li>
                </ul>
              </div>

              <div className='mt-4'>
                <h5>3. Scores, Coins, and Rewards</h5>
                <p>We reserve the right to:</p>
                <ul>
                    <li>Reset scores or coins</li>
                    <li>Modify reward systems</li>
                    <li>Remove suspicious activity</li>
                    <li>Update quiz rules anytime</li>
                </ul>
              </div>

              <div className='mt-4'>
                <h5>4. Intellectual Property</h5>
                <p>All website content including:</p>
                <ul>
                    <li>Quizzes</li>
                    <li>Design</li>
                    <li>Logos</li>
                    <li>Images</li>
                    <li>Text</li>
                    <li>Code</li>
                </ul>
              </div>

              <div className='mt-4'>
                <h5>5. Website Availability</h5>
                <p>We do not guarantee uninterrupted access to the website. Features may be updated, modified, or removed at any time without notice.</p>
               
              </div>
              
              <div className='mt-4 mb-5'>
                <h5>6. Changes to Terms</h5>
                <p>We may update these Terms and Conditions at any time. Continued use of the website after updates means you accept the revised terms.</p>
               
              </div>
              </div>
            </div>
      </div>
      </div>
      </div>
    </>
  )
}

export default Terms

